document.addEventListener("DOMContentLoaded", () => {
  const stlWrapper = document.querySelectorAll(".stl_wrapper");
  stlWrapper.forEach((wrapper) => {
    const imageWrapper = wrapper.querySelector(".image_wrapper");
    const productWrapper = wrapper.querySelector(".products");
    const products = wrapper.querySelectorAll(".product_wrapper");
    const image = imageWrapper.querySelector("img");

    function updateProductWrapperHeight() {
      const imageHeight = image.offsetHeight;
      productWrapper.style.height = imageHeight + "px";
    }

    if (window.innerWidth > 1200) {
      updateProductWrapperHeight();

      window.addEventListener("resize", () => {
        if (window.innerWidth > 1200) {
          updateProductWrapperHeight();
        } else {
          productWrapper.style.height = "auto";
        }
      });
    }

    function centerProductVertically(product) {
      let container = document.querySelector(".products_wrapper");
      let containerRect = container.getBoundingClientRect();
      let productRect = product.getBoundingClientRect();
      let targetOffset =
        productRect.top -
        containerRect.top -
        containerRect.height / 2 +
        productRect.height / 2;
      let initialOffset = container.scrollTop;
      let distance = Math.abs(targetOffset - initialOffset);
      let duration = 300;
      let delay = 500;
      let startTime = null;

      setTimeout(function () {
        function scrollStep(timestamp) {
          if (!startTime) {
            startTime = timestamp;
          }
          let progress = timestamp - startTime;
          let percentage = Math.min(progress / duration, 1);
          container.scrollTop = initialOffset + targetOffset * percentage;
          if (progress < duration) {
            window.requestAnimationFrame(scrollStep);
          }
        }
        window.requestAnimationFrame(scrollStep);
      }, delay);
    }

    function centerProductHorizontally(product) {
      let container = document.querySelector(".products_wrapper");
      let containerRect = container.getBoundingClientRect();
      let productRect = product.getBoundingClientRect();
      let targetOffset =
        productRect.left -
        containerRect.left -
        containerRect.width / 2 +
        productRect.width / 2;
      let initialOffset = container.scrollLeft;
      let distance = Math.abs(targetOffset - initialOffset);
      let duration = 300;
      let delay = 500;
      let startTime = null;

      setTimeout(function () {
        function scrollStep(timestamp) {
          if (!startTime) {
            startTime = timestamp;
          }
          let progress = timestamp - startTime;
          let percentage = Math.min(progress / duration, 1);
          container.scrollLeft = initialOffset + targetOffset * percentage;
          if (progress < duration) {
            window.requestAnimationFrame(scrollStep);
          }
        }
        window.requestAnimationFrame(scrollStep);
      }, delay);
    }

    const dots = wrapper.querySelectorAll(".dot_wrapper .dot");
    dots.forEach((dot) => {
      const productId = dot.dataset.id;
      dot.addEventListener("mouseenter", () => {
        dot.classList.add("active");
        products.forEach((product) => {
          if (product.dataset.id == productId) {
            product.classList.add("active");
            if (window.innerWidth > 1200) {
              centerProductVertically(product);
            } else {
              centerProductHorizontally(product);
            }
          }
        });
      });
      dot.addEventListener("mouseleave", () => {
        dot.classList.remove("active");
        products.forEach((product) => {
          if (product.dataset.id == productId) {
            product.classList.remove("active");
          }
        });
      });
    });
  });
});
